import React, { useState, useEffect } from "react";
import { get, useForm } from "react-hook-form";
import Spinner from "../../../../../components/Spinner";
import AuthContext from "../../../../../contexts/auth";
import NotifyC from "../../../../../components/Notifications";
import { useHistory } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { FaCheckCircle, FaLockOpen } from "react-icons/fa";
import { RiHomeOfficeFill } from "react-icons/ri";
import { FaArrowLeft } from "react-icons/fa";
import SelectSearch from "../../../../../components/ui/SelectSearch";
import {useOffice} from "../../../../../hooks/useOffice";
import Swal from "sweetalert2";
import "./HorizontalStepper.css";

const HorizontalStepper = () => {
    const { register, reset, watch, handleSubmit, formState: { errors } } = useForm({
        defaultValues: {
            province: '',
            code: '',
            name: '',
            address: '',
            phone: '',
        }
    });
  
    const {createOffice, getListProvinces } = useOffice();
    const [isLoading, setIsLoading] = useState(false);
    const [provinces, setProvinces] = useState([]);
    const [selectedProvince, setSelectedProvince] = useState(null);
    const [controlStep, setControlStep] = useState({
        provinceStep: false,
        codeStep: false,
        nameStep: false,
        addressStep: false,
        phoneStep: false,
        submitBtn: false,
    });

    const onSubmit = async (data) => {
        const abortController = new AbortController();
        try{
            setIsLoading(true);

            const dataToSend = {
                IdProvincia: selectedProvince,
                Codigo: data.code,
                Nombre: data.name,
                Direccion: data.address,
                IdEstatus: 1,
                Telefono: data.phone,
            };
            
            const response = await createOffice (abortController.signal, dataToSend);
            
            if (response?.code === 200) {
                Swal.fire({
                    icon: "success",
                    title: "Estafeta creada",
                    html: `La estafeta ha sido creada exitosamente <br/>
                    <b>Código:</b> ${response.payload.CodigoEstafeta} <br/>
                    <b>Nombre:</b> ${response.payload.NombreEstafeta} <br/>`,
                    confirmButtonText: "Ok",
                    customClass: {
                    confirmButton: 'custom-confirm-button',
                    },
                });
    
                resetForm();
            } else {
                if (response?.code === 400) {
                    switch (response.message) {
                        case "OFFICE_CODE_ALREADY_EXISTS":
                         NotifyC.error("El código de la estafeta ya existe");
                            break;
                        case "OFFICE_NAME_ALREADY_EXISTS":
                            NotifyC.error("El nombre de la estafeta ya existe");
                            break;
                        default:
                            NotifyC.error("Ha ocurrido un error inesperado, intentalo de nuevo");
                            break;
                }
             }
            }
            setIsLoading(false);
        } catch {
        
            setIsLoading(false);
            Swal.fire({
                icon: "error",
                title: "Error al crear la estafeta",
                text: "Ha ocurrido un error inesperado, intentalo de nuevo",
                confirmButtonText: "Ok",
                customClass: {
                confirmButton: 'custom-confirm-button',
                },
            });
        }
    };

    const handleGetListProvinces = async () => {
        const abortController = new AbortController();
        try {
            const response = await getListProvinces(abortController.signal);
            if (response.length > 0) {
                setProvinces(response);
            } else {
                NotifyC.error("Error al obtener las provincias");
            }
        } catch (error) {
            NotifyC.error("Error al obtener las provincias");
        }
    };

    const handleSelect = (name, value) => {
        if (name === "province") {
            setSelectedProvince(value);
        }
    };


    const resetForm = () => {
        reset();
        setControlStep({
            codeStep: false,
            nameStep: false,
            addressStep: false,
            phoneStep: false,
            submitBtn: false,
        });
    };

    const validateSteps = () => {
        setControlStep({
            provinceStep: selectedProvince !== null,
            codeStep: selectedProvince !== null && !!watch("code").trim(),
            nameStep:selectedProvince !== null && !!watch("code").trim() && !!watch("name").trim(),
            addressStep:selectedProvince !== null && !!watch("code").trim() && !!watch("name").trim() && !!watch("address").trim(),
            phoneStep:selectedProvince !== null && !!watch("code").trim() && !!watch("name").trim() && !!watch("address").trim() && !!watch("phone").trim(),
            submitBtn: selectedProvince !== null &&!!watch("code").trim() && !!watch("name").trim() && !!watch("address").trim() ,
        });
    };
    
    const renderInput = (field, label, required, type, placeholder) => (
        <div className="form-group text-left">
            <label>
                {label} {required && <span className="text-danger">*</span>}
            </label>
            <input
                type={type ?? "text"}
                className="form-control"
                name={field}
                ref={register({
                    required: required ? "Este campo es obligatorio" : false
                })}
                onChange={() => validateSteps(field)}
                placeholder={placeholder
                    ? placeholder
                    : `Ingrese ${label.toLowerCase()}`
                }
            />
            {errors[field] && (
                <span className="text-danger">{errors[field].message}</span>
            )}
        </div>
    );

    const steps = [
        {
            label: "Provincia",
            icon: <RiHomeOfficeFill size={20} />,
            bgIcon: "#fbd825",
            content: (
                <div className="horizontal-stepper">
                    <div className="form-group text-left">
                        <label>
                            Provincia <span className="text-danger">*</span>
                        </label>
                        <SelectSearch
                        nameInput={"province"}
                        placeholder="Seleccione una provincia"
                        options={provinces}
                        setValue={handleSelect}
                        value={selectedProvince}
                    />
                    </div>
                  
                </div>
            ),

        },
        {
            label: "Código",
            icon: <RiHomeOfficeFill size={20} color="black" />,
            bgIcon: "#fbd825",
            content: (
                <div className="horizontal-stepper">
                    {renderInput("code", "Código", true, "text", "Código de la estafeta")}
                </div>
            ),
        },
        {
            label: "Nombre",
            icon: <RiHomeOfficeFill size={20} />,
            bgIcon: "#e2131b",
            content: (
                <div className="horizontal-stepper">
                    {renderInput("name", "Nombre", true, "text", "Nombre de la estafeta")}
                </div>
            ),
        },
        {
            label: "Dirección",
            icon: <RiHomeOfficeFill size={20} />,
            bgIcon: "#0c4271",
            content: (
                <div className="horizontal-stepper">
                    {renderInput("address", "Dirección", true, "text", "Dirección de la estafeta")}
                </div>
            ),
        },
        {
            label: "Teléfono",
            icon: <RiHomeOfficeFill size={20} />,
            bgIcon: "#0c4271",
            content: (
                <div className="horizontal-stepper">
                    {renderInput("phone", "Teléfono", false, "text", "Teléfono de la estafeta")}
                </div>
            ),
        },
    ];



    useEffect(() => {
        validateSteps();
    }, [watch("code"), watch("name"), watch("address"), watch("phone"), selectedProvince]);

    useEffect(() => {
        handleGetListProvinces();
    }, []);

    return (
        <>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "30px",
                }}
            >
                <div
                    style={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                        background: `#0c4271`,
                        color: "white",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: "10px",
                    }}
                >
                    <RiHomeOfficeFill size={20} />
                </div>
                <span style={{ fontSize: "18px", fontWeight: "500" }}>
                    Informacion de la Estafeta
                </span>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                    {steps.map((step, index) => (
                        <div
                            key={index}
                            className="col-12 col-md-3"
                            style={{ marginBottom: "20px", borderBottom: "1px dashed #e3e3e3" }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: "10px",
                                }}
                            >
                                <div
                                    style={{
                                        width: "30px",
                                        height: "30px",
                                        borderRadius: "50%",
                                        background: `${step.bgIcon}`,
                                        color: step.colorIcon ?? "white",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        marginRight: "10px",
                                    }}
                                >
                                    {step.icon}
                                </div>
                                <span style={{ fontSize: "18px", fontWeight: "500" }}>
                                    {step.label}
                                </span>
                            </div>
                            <CSSTransition
                                in={
                                    index === 0 ||
                                    (index === 1 && controlStep.provinceStep) ||
                                    (index === 2 && controlStep.codeStep) ||
                                    (index === 3 && controlStep.nameStep) ||
                                    (index === 4 && controlStep.addressStep) 
                                }
                                timeout={200}
                                classNames="step"
                                unmountOnExit
                            >
                                <div className="px-1">{step.content}</div>
                            </CSSTransition>

                        </div>
                    ))}
                </div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "end",
                        gap: "10px",
                        marginTop: "20px",
                    }}
                >
                   
                    <button
                        type="submit"
                        className="btn btn-blue"
                        disabled={!controlStep.submitBtn || isLoading}
                    >
                        {isLoading ? <Spinner type={1} /> : <><FaCheckCircle /> Crear estafeta</>}
                    </button>
                </div>
            </form>
        </>
    );
};

const CreateEstafeta = () => {
    const history = useHistory();
    return (
        <>
            <div className="dashboardCard text-left" style={{ color: "black" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap" }}>
            <div className="d-flex align-items-center" style={{ gap: "15px", flex: "1" }}>
                    <RiHomeOfficeFill size={20} className="mr-1" />
                    <h5 className="mb-0">Crear Estafeta</h5>
                </div>
              
                <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => history.push("/dashboard/administration/postoffices")}
                    >
                        <FaArrowLeft /> Regresar
                    </button>
                    </div>
            </div>
            <div className="dashboardCard">
                <HorizontalStepper />
            </div>
        </>
    );
};

export default CreateEstafeta;